import { axios } from "../../lib/axios";

export const DeleteCoupon = (faqId: string) => {
    return axios.delete(`/coupon/${faqId}`)
        .then(response => response.data);
};